import '../assets/styles/main.less'

import {lazy, Suspense} from 'react'
import {Outlet} from 'react-router-dom'

import {RootProvider} from '../context/RootContext'
import NotFound from '../features/not-found/NotFound'
import BaseLayout from '../layouts/BaseLayout'
import {APP_ROUTES} from './routes'

export const Loading = () => {
  return (
    <div className="creditstar-spinner-wrapper">
      <div className="creditstar-spinner"></div>
    </div>
  )
}

const SuspenseLoader = Component => () =>
  <Suspense fallback={<Loading />}>
    <Component />
  </Suspense>

const HomePage = SuspenseLoader(lazy(() => import('../features/home/Home')))
const CareersPage = SuspenseLoader(lazy(() => import('../features/careers/Careers')))
const CareerListPage = SuspenseLoader(lazy(() => import('../features/career-list/CareerList')))
const CareerDetailPage = SuspenseLoader(lazy(() => import('../features/career-detail/CareerDetail')))
const AboutPage = SuspenseLoader(lazy(() => import('../features/about/About')))
const ProductsPage = SuspenseLoader(lazy(() => import('../features/products/Products')))
const BondsPage = SuspenseLoader(lazy(() => import('../features/bonds/Bonds')))
const NewsPage = SuspenseLoader(lazy(() => import('../features/news/News')))
const ArticlePage = SuspenseLoader(lazy(() => import('../features/article/Article')))
const ContactsPage = SuspenseLoader(lazy(() => import('../features/contacts/Contacts')))
const DirectLoansPage = SuspenseLoader(lazy(() => import('../features/direct-loans/DirectLoans')))
const InvestorInformation = SuspenseLoader(lazy(() => import('../features/investor-information/InvestorInformation')))
const CookiePolicyPage = SuspenseLoader(lazy(() => import('../features/cookie-policy/CookiePolicy')))
const DisclaimerPage = SuspenseLoader(lazy(() => import('../features/disclaimer/Disclaimer')))

const BaseLayoutView = () => {
  return (
    <RootProvider>
      <BaseLayout>
        <Outlet />
      </BaseLayout>
    </RootProvider>
  )
}

const publicRoutes = [
  {
    element: <BaseLayoutView />,
    children: [
      {path: APP_ROUTES.ROOT, element: <HomePage />},
      {path: APP_ROUTES.CAREERS, element: <CareersPage />},
      {path: APP_ROUTES.CAREERS_LIST, element: <CareerListPage />},
      {path: APP_ROUTES.CAREERS_DETAIL, element: <CareerDetailPage />},
      {path: APP_ROUTES.ABOUT, element: <AboutPage />},
      {path: APP_ROUTES.PRODUCTS, element: <ProductsPage />},
      {path: APP_ROUTES.BONDS, element: <BondsPage />},
      {path: APP_ROUTES.NEWS, element: <NewsPage />},
      {path: APP_ROUTES.ARTICLE, element: <ArticlePage />},
      {path: APP_ROUTES.CONTACTS, element: <ContactsPage />},
      {path: APP_ROUTES.DIRECT_LOANS, element: <DirectLoansPage />},
      {path: APP_ROUTES.INVESTOR_INFORMATION, element: <InvestorInformation />},
      {path: APP_ROUTES.COOKIE_POLICY, element: <CookiePolicyPage />},
      {path: APP_ROUTES.DISCLAIMER, element: <DisclaimerPage />}
    ]
  }
]

const appRoutes = [
  {
    element: <BaseLayoutView />,
    children: [
      {path: APP_ROUTES.INVALID, element: <NotFound />},
      {path: APP_ROUTES.NOT_FOUND, element: <NotFound />}
    ]
  }
]

export const router = [
  ...publicRoutes,
  ...appRoutes
]
